<template>
    <div class="tip-tap-component">
        <div class="items" v-loading="loading_search">
            <template v-if="items && items.length > 0">
                <button
                    class="item"
                    :class="{ 'is-selected': index === selectedIndex }"
                    v-for="(item, index) in items"
                    :key="index"
                    @click="selectItem(index)"
                >
                    {{ item }}
                </button>
            </template>
            <div class="item" v-else>
                No result
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { useMessagingStore } from '@/stores/messagingStore'

export default {
    props: {
        items: {
            type: Array,
            required: true,
        },

        command: {
            type: Function,
            required: true,
        },
    },

    data() {
        return {
            selectedIndex: 0,
        }
    },

    watch: {
        items() {
            this.selectedIndex = 0
        },
    },

    computed: {
        ...mapState(useMessagingStore,['loading_search']),
    },

    methods: {
        onKeyDown({ event }) {
            if (event.key === 'ArrowUp') {
                this.upHandler()
                return true
            }

            if (event.key === 'ArrowDown') {
                this.downHandler()
                return true
            }

            if (event.key === 'Enter') {
                this.enterHandler()
                return true
            }

            return false
        },

        upHandler() {
            this.selectedIndex = ((this.selectedIndex + this.items.length) - 1) % this.items.length
        },

        downHandler() {
            this.selectedIndex = (this.selectedIndex + 1) % this.items.length
        },

        enterHandler() {
            this.selectItem(this.selectedIndex)
        },

        selectItem(index) {
            const item = this.items[index]

            if (item) {
                this.command({ id: item })
            }
        },
    },
}
</script>